module.exports = __webpack_public_path__ + "static/media/ELABORADO_GRIS.b1cbfc74.svg";